import http from "@/utils/http";

// 添加老师（新建用户）
export function addTeacher(data) {
  return http({
    url: "/user/teacher/add",
    method: "POST",
    data
  });
}

// 添加老师（新建用户）
export function addManage(data) {
  return http({
    url: "/user/manager/add",
    method: "POST",
    data
  });
}

// 添加老师（新建用户）
export function addRegTeacher(data) {
  return http({
    url: "/user/teacher/add/" + data,
    method: "POST"
  });
}

// 添加管理员-通过已有用户添加
export function addRegManage(data) {
  return http({
    url: "/user/manager/add/" + data,
    method: "POST"
  });
}
// 分页查询员工
export function getWorkers(data) {
  return http({
    url: "/user/staffs" + data,
    method: "GET"
  });
}

// 职员激活
export function active(data) {
  return http({
    url: "/user/staff/active?userid=" + data,
    method: "POST"
  });
}

// 职员暂停使用（冻结）
export function stop(data) {
  return http({
    url: "/user/staff/frozen?userid=" + data,
    method: "POST"
  });
}

// 换权限员工
export function resetWorker(id, role) {
  return http({
    url: "/user/staff/changerole?userid=" + id + "&roleid=" + role,
    method: "POST"
  });
}

// 减员
export function removeWorker(id) {
  return http({
    url: "/user/staff/remove?userid=" + id,
    method: "POST"
  });
}
